module.exports = __webpack_public_path__ + "img/qr-code-primeira-caixa.1391eac9.png";